import { useEffect } from "react";

const useKeyboardSubmit = (handleSubmit, onSubmit, options = {}) => {
  const { enableOnInputs = true } = options;

  useEffect(
    () => {
      const handleKeyDown = event => {
        const isMac = navigator.platform.toUpperCase().includes("MAC");
        const isSaveShortcut =
          (isMac && event.metaKey && event.key === "s") ||
          (!isMac && event.ctrlKey && event.key === "s");

        if (isSaveShortcut) {
          if (!enableOnInputs) {
            const active = document.activeElement;
            const isTyping =
              active.tagName === "INPUT" ||
              active.tagName === "TEXTAREA" ||
              active.isContentEditable;

            if (isTyping) return;
          }

          event.preventDefault();
          handleSubmit(onSubmit)();
        }
      };

      window.addEventListener("keydown", handleKeyDown);

      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    },
    [handleSubmit, onSubmit, enableOnInputs]
  );
};

export default useKeyboardSubmit;
